import { apiGet, apiPatch } from './http';

// ── Acesso: a mesma verdade que a app lean consome (/access/me) ──
export interface Access {
  authenticated: boolean;
  isStaff: boolean;
  isOrganizer: boolean;
  permissions: string[];
  user?: { id: string; email?: string; full_name?: string } | null;
}
export const getAccess = () => apiGet<Access>('/access/me');

// ── Perfil próprio (/users/me) — a consola só precisa das preferências de
// apresentação; a identidade já vem do Clerk e do /access/me. `preferences.theme`
// é a preferência claro/escuro que viaja com a pessoa entre dispositivos.
export interface MyProfile { id: string; preferences?: Record<string, unknown> | null }
export const getMyProfile = () => apiGet<MyProfile>('/users/me');

// PATCH /users/me/preferences — `null` limpa a escolha (volta a seguir o sistema).
export const setThemePreference = (theme: 'dark' | 'light' | null) =>
  apiPatch<{ ok: boolean; theme: string | null }>('/users/me/preferences', { theme });

// Idioma da interface — viaja com a conta (preferences.locale).
export const setLocalePreference = (locale: 'pt' | 'en' | 'fr' | 'es' | null) =>
  apiPatch<{ ok: boolean; locale: string | null }>('/users/me/preferences', { locale });

// ── Dashboard de sistema (/admin/dashboard) ──
export interface Dashboard {
  // number | null — null quando a API não conseguiu ler a métrica (ver
  // `degraded`). NÃO é 0: um zero é um facto, um null é a ausência de facto.
  users: number | null; events: number | null; liveEvents: number | null;
  checkins: number | null; connections: number | null; totalMXC: number | string | null;
  timestamp: string;
  /** Métricas que a API não conseguiu ler nesta resposta. Ausente = todas OK. */
  degraded?: string[];
}
export const getDashboard = () => apiGet<Dashboard>('/admin/dashboard');

// ── Utilizadores (/admin/users) ──
export interface AdminUser {
  id: string; full_name: string | null; email: string; company: string | null;
  job_title: string | null; tier: string | null; user_role: string | null;
  xp: number | null; is_active: boolean; created_at: string;
}
export interface UsersPage { data: AdminUser[]; total: number; limit: number; offset: number }
export function listUsers(params: { search?: string; role?: string; limit?: number; offset?: number } = {}) {
  const q = new URLSearchParams();
  if (params.search) q.set('search', params.search);
  if (params.role) q.set('role', params.role);
  q.set('limit', String(params.limit ?? 50));
  q.set('offset', String(params.offset ?? 0));
  return apiGet<UsersPage>(`/admin/users?${q.toString()}`);
}
export function setUserActive(id: string, is_active: boolean) {
  return apiPatch<{ ok: boolean }>(`/admin/users/${id}`, { is_active });
}

// ── Eventos (/admin/events) ──
export interface AdminEvent {
  id: string; title: string; status: string | null; sector: string | null;
  venue_city: string | null; venue_name?: string | null; starts_at: string | null; organizer_name: string | null;
  tickets_sold: number | string | null; checkins: number | string | null;
  max_attendees?: number | null; attendees_count?: number | null; match_avg?: number | string | null;
}

// Lista de eventos (para o card «Eventos em operação» do Overview). Reutiliza
// /admin/events — mesma fonte da página de Eventos, sem endpoint novo.
export const getAdminEvents = () =>
  apiGet<{ data: AdminEvent[] } | AdminEvent[]>('/admin/events').then(
    (r) => (Array.isArray(r) ? r : r.data ?? []),
  );
